export default __webpack_public_path__ + "static/media/pacmanl.bd31e027.svg";